var Payment3DSStrategy = (function (_, $, PaymentStrategy) {

	var Payment3DSStrategy = function (attrs) {
		PaymentStrategy.apply(this, arguments);

		_.extend(this, {
			threeDSAPI: null,

			// TBD: this class needs only total, not whole summary model
			summaryModel: null,

            deliveryServicePackageDetail: null,

			currentMethod: null
		}, attrs);
	};

	Payment3DSStrategy.prototype = _.extend(window.app.jsUtils.createObjectWithProto(PaymentStrategy.prototype), {
		constructor: Payment3DSStrategy,

		betweenProcessAndComplete: function (data) {
            if (CheckoutSettings.PaymentType.PayPal === data.PaymentType) {
                return PromiseUtil.resolved(data);
            }

			if (!(data && data.Nonce)) {
				var _this = this;
				return window.api.getPaymentMethodNonce(this.currentMethod.get('Token')).pipe(function (resp) {
					return _this._call3DS(_.extend({}, data, {
						Nonce: resp.Value && resp.Value.Nonce,
						Bin: resp.Value && resp.Value.Bin
					}));
				});
			}

			return this._call3DS(data);
		},

        _call3DS: function (data) {
            var total = this.summaryModel.get('Total');
            if (this.deliveryServicePackageDetail.get('Purchased') === false) {
                total = this.deliveryServicePackageDetail.get('Amount');
            }
            return this.threeDSAPI.verify3DS(data.Nonce, total, data.Bin, this.delivery.toJSON());
		}
	});

	return Payment3DSStrategy;
})(_, $, PaymentStrategy);
